import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

interface RecurrencyExceptionResponse {
  user_uuid: string
  exception_date_utc: string
  exception_type: string
  next_available_date: string
}

interface PatientReservationResponse {
  reservation_uuid: string
  recurrence: 'Semanal'| 'Avulsa'
  patient_username: string
  professional_full_name: string
  professional_picture_url: string
  professional_username: string
  start_date: string
  recurrency_exceptions: RecurrencyExceptionResponse[]
}

interface PatientReservationResponseData {
  reservations: PatientReservationResponse[]
}

export async function getPatientReservations(patientUsername: string): Promise<PatientReservationResponseData> {
  const isProfessional = false
  const { data } = await axios.get<PatientReservationResponseData>(apiEndpoints.RESERVATIONS(patientUsername, isProfessional))
  
  return data
}